import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../services/api';
import { Cat, Bron, Thumb, Markdown, fmt } from '../components/nieuws/nieuwsUtil';

export default function NieuwsArtikel() {
  const { id } = useParams();
  const nav = useNavigate();
  const [n, setN] = useState(null);
  const [fout, setFout] = useState('');
  useEffect(() => { api.get(`/nieuws/${id}`).then((r) => setN(r.data)).catch(() => setFout('Artikel niet gevonden')); }, [id]);

  return (
    <div style={{ maxWidth: 820, margin: '0 auto' }}>
      <button onClick={() => nav('/nieuw')} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', fontSize: 14, padding: '8px 0', marginBottom: 8 }}>← Alle berichten</button>
      {fout && <p style={{ color: '#6b7280' }}>{fout}</p>}
      {n && (
        <article style={{ background: '#fff', borderRadius: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
          {n.afbeelding_url && <Thumb n={n} height={380} />}
          <div style={{ padding: '32px 40px 40px' }}>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}><Cat c={n.categorie} /><Bron n={n} /></div>
            <h1 style={{ fontSize: 32, lineHeight: 1.2, margin: '16px 0 10px' }}>{n.titel}</h1>
            <div style={{ color: '#9ca3af', fontSize: 14, marginBottom: 24 }}>{fmt(n.publicatie_datum)} · {n.auteur_voornaam} {n.auteur_achternaam}</div>
            {n.intro && <p style={{ fontSize: 18, color: '#4b5563', lineHeight: 1.55, margin: '0 0 24px', fontWeight: 500 }}>{n.intro}</p>}
            <Markdown tekst={n.tekst} />
          </div>
        </article>
      )}
    </div>
  );
}
